"use client";

import Link from "next/link";
import { MailboxIcon } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

type AuthSupportFooterProps = {
  className?: string;
};

const AuthSupportFooter = ({ className }: AuthSupportFooterProps) => {
  return (
    <div
      className={cn(
        "flex items-center justify-center gap-2 flex-wrap text-sm sm:text-base font-normal mt-10 sm:mt-12 md:mt-16 tracking-[-0.02em] text-[var(--gray-500)]",
        className,
      )}
    >
      <MailboxIcon size={28} />
      <a href="mailto:Support@fixrli.com" className={cn("hover:underline")}>
        Support@fixrli.com
      </a>
      <span>•</span>
      <Link href="/privacy" className={cn("hover:underline")}>
        Privacy Policy
      </Link>
    </div>
  );
};

export default AuthSupportFooter;
